import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Grid,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import Card from "../../components/Cards/Card";
import NativeObject from "../../components/NativeObject/NativeObject";
import { useSelections } from "../../context/Selections";
import styled from "styled-components";

const LayoutCardWrapper = styled.div`
  border-radius: 16px;
  display: flex;
  width: 100%;
  padding-right: 10px;
`;

const LayoutCardsWrapper = styled("div")({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: "94%",
  justifyContent: "flex-start",
  width: "100%",
});

function DetailsDesktop({ app, config }) {
  const [selectedValueCargo, setSelectedValueCargo] = useState("Resumo");
  const { selections } = useSelections();


  const handleChange = (event) => {
    app.field("Detalhe").selectMatch(event.target.value, true);
    setSelectedValueCargo(event.target.value);
  };

  useEffect(() => {
    if (app) {
      // update title with selected distributor (when only 1 is selected)
      const cargos = selections.length
        ? selections.find((s) => s.qField === "Detalhe")
        : null;
      setSelectedValueCargo(cargos?.qSelected);
      console.log(cargos?.qSelected);
    }
  }, [app, selections]);

  return (
    <div className="app deatil">
      <div className="appContent">
        <LayoutCardsWrapper>
          <Grid container rowGap={2}>
            <LayoutCardWrapper
              style={{
                paddingLeft: "10px",
                marginTop: "16px",
                height: "calc(100vh - 100px)",
              }}
            >
              <Card
                app={app}
                exportTable
                exportTableId="ZAEyS"
                exportContainer

                style={{ width: "100%", height: "100%" }}
                className={"container-table"}
              >
                <FormControl className="container-form-control">
                  <RadioGroup
                    defaultValue="Gerente Geral"
                    row
                    name="row-radio-buttons-group"
                    className="radio-group radio-group-button-export"
                    value={selectedValueCargo}
                    onChange={handleChange}
                  >
                    <FormControlLabel
                      value="Resumo"
                      control={
                        <Radio
                          size="small"
                          defaultChecked
                          sx={{
                            color: "#027E9E",
                            "&.Mui-checked": {
                              color: "#027E9E",
                            },
                          }}
                        />
                      }
                      label="Resumo"
                    />

                    <FormControlLabel
                      value="Detalhamento Completo"
                      control={
                        <Radio
                          size="small"
                          sx={{
                            color: "#027E9E",
                            "&.Mui-checked": {
                              color: "#027E9E",
                            },
                          }}
                        />
                      }
                      label="Detalhamento Completo"
                    />
                  </RadioGroup>
                </FormControl>

                <NativeObject
                  app={app}
                  key="ZAEyS"
                  reference={{ id: "ZAEyS" }}
                  style={{height: '100%', marginTop: '10.2px'}}
                />
              </Card>
            </LayoutCardWrapper>
          </Grid>
        </LayoutCardsWrapper>
      </div>
    </div>
  );
}

DetailsDesktop.defaultProps = {
  app: null,
  config: {},
};

DetailsDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default DetailsDesktop;
